/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type WorkingTimeImportStatus = typeof WorkingTimeImportStatus[keyof typeof WorkingTimeImportStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingTimeImportStatus = {
  New: 'New',
  Edited: 'Edited',
  Revised: 'Revised',
  Requested: 'Requested',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Finished: 'Finished',
  Failed: 'Failed',
  Deleted: 'Deleted',
  FinishedWithTimeRuleValidationError: 'FinishedWithTimeRuleValidationError',
  Cancelled: 'Cancelled',
  FinishedAfterRevised: 'FinishedAfterRevised',
} as const;
